import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'address-view',
  template: `
    <app-address-view
      *ngIf="model && model[props.addressKey]"
      [legend]="props.legend | translate"
      [address]="model[props.addressKey]">
    </app-address-view>
  `,
})
export class FormlyAddressViewTypeComponent extends FieldType {

}
